import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material';
import { UsuarioService } from '../../services/usuario.service';
import { XsAppConfigService } from 'src/app/common/services/xs-app-config.service';
import { XsMessageBoxComponent } from 'src/app/common/widgets/xs-message-box/xs-message-box.component';
import { CookieService } from 'ngx-cookie-service';
import { CorreoService } from '../../services/correo.service';

export interface Parametro{
  opcion: string;
  idUsuarioRuc: number;
}

@Component({
  selector: 'app-usuario-secundario-detalle',
  templateUrl: './usuario-secundario-detalle.component.html',
  styleUrls: ['./usuario-secundario-detalle.component.css']
})
export class UsuarioSecundarioDetalleComponent implements OnInit {

  solicitud: any = {};
  listaTipoDocumento: [];
  listaEstado: [];
  ingresarDatos: boolean;
  // @ViewChild('name', {static: true}) nombre: ElementRef;
  constructor(
    @Inject(MAT_DIALOG_DATA) public parametro: Parametro,
    public usuarioService: UsuarioService,
    public xsAppConfigService: XsAppConfigService,
    public dialogRef: MatDialogRef<UsuarioSecundarioDetalleComponent>,
    public dialog: MatDialog,
    public correoService: CorreoService,
    private cookieService: CookieService
  ) { }

  opciones = [
    {eNroOrden:3}, 
    {eNroOrden:0}, 
    {eNroOrden:1}, 
    {eNroOrden:6}, 
    {eNroOrden:2}, 
    // {eNroOrden:4}, 
    {eNroOrden:5}, 
    {eNroOrden:7}, 
    // {eNroOrden:8}
  ]; //solo para localhost
  op: any = [];
  ngOnInit() {
    this.inicializar();
  }

  inicializar(){
   /* this.usuarioService.inicializar(this.parametro).then(res =>{
      this.listaTipoDocumento = res.data.listaTipoDocumento;
      this.listaEstado = res.data.listaEstado;
      this.solicitud = res.data.usuario;
      if (res.data.opciones != "[]")
        this.opciones = JSON.parse(res.data.opciones);
    }); */
  }

  insertDocument(){
    this.solicitud.usuario = this.solicitud.nroDocumento;
  }

  usuarioExiste: number = 0;
  onClickBuscar(){
    this.ingresarDatos = false;
    if (!this.solicitud.nroDocumento){
      this.mostrarMensajeDialog("Ingrese número de documento");
      return;
    } 
    /*this.usuarioService.obtenerAdministrado(this.solicitud).then(res => {
      this.solicitud = res.data.administrado;
      this.usuarioExiste = res.data.usuarioExiste;
      this.solicitud.usuario = this.solicitud.nroDocumento;
      if (this.solicitud.idUsuario == null || this.solicitud.idUsuario == 0) {
        this.mostrarMensajeDialog("La información del DNI ingresado no fue encontrado, ¿Desea registrar manualmente la información?.");
        this.ingresarDatos = true;
      }
      if(this.usuarioExiste > 0){
        this.mostrarMensajeDialog("Este usuario ya tiene una cuenta con otro Administrado, asegúrese que el correo electrónico que ingresará sea distinto al que fue ingreso anteriormente. Para afiliarlo a este Administrado ya no es necesario asignarle una contraseña de acceso, podrá acceder con las credenciales que ya tiene.");
      }
    });*/
    // this.usuarioService.mensaje({}).then(res =>{
      
    // })
  }

  onClickAceptar(){
    if (!this.validarCampos()) return;
    switch(this.parametro.opcion){
      case "AGREGAR":
        this.solicitud.ruc = this.cookieService.get("usuarioRuc");
        this.solicitud.idUsuarioPrincipal = this.cookieService.get("idUsuario");
        this.solicitud.idTipoUsuario = "2";
        this.solicitud.idEstado = "1";
        for (let i = 0; i < this.opciones.length; i++){
          this.op.push(this.opciones[i].eNroOrden);
        }
        this.solicitud.opciones = this.op;
       /* this.usuarioService.agregar(this.solicitud).then(res =>{
          // if (res.data.observacion == null || res.data.observacion == "null" || res.data.observacion == "") {
          if(res.data.estado){
            if (this.usuarioExiste==0){
              this.sendMail();
            }
            this.mostrarMensajeDialog("Usuario creado");
            this.dialogRef.close({ data: null, estado: "ACEPTAR" });
          // } else {
          //   this.mostrarMensajeDialog(res.data.observacion);
          }
        });*/
        break;
      case "MODIFICAR":
        /*this.usuarioService.modificar(this.solicitud).then(res =>{
          this.dialogRef.close({ data: null, estado: "ACEPTAR" });
        });*/
        break;
      case "ELIMINAR":
       /* this.usuarioService.eliminar(this.solicitud).then(res =>{
          this.dialogRef.close({ data: null, estado: "ACEPTAR" });
        });*/
    }
  }

  onClickCancelar(){
    this.dialogRef.close({ data: null, estado: "CANCELAR" });
  }

  titulo(){
    switch(this.parametro.opcion){
      case "AGREGAR": return "AGREGAR USUARIO SECUNDARIO";break
      case "MODIFICAR": return "MODIFICAR USUARIO SECUNDARIO";break
      case "ELIMINAR": return "ELIMINAR USUARIO SECUNDARIO";break
    }
  }

  validarCampos() {
    var errores = "";
    if (this.solicitud.clave != this.solicitud.clave2 && this.parametro.opcion == "AGREGAR" && this.usuarioExiste==0) {
      errores = "<br>Las contraseñas ingresados no coinsiden";
    }
    if (!this.solicitud.clave && this.parametro.opcion == "AGREGAR" && this.usuarioExiste==0) {
      errores = "<br>Ingrese clave se seguridad";
    }
    if (!this.solicitud.usuario) {
      errores = "<br>Ingrese usuario";
    }
    if (!this.solicitud.correo) {
      errores = "<br>Ingrese correo electrónico";
    }
    if (!this.solicitud.apellidoPaterno) {
      this.ingresarDatos = true;
      errores = "<br>Ingrese apellido paterno";
    }
    if (!this.solicitud.nombres) {
      this.ingresarDatos = true;
      errores = "<br>Ingrese nombre";
    }
    if (!this.solicitud.nroDocumento) {
      errores = "<br>Ingrese número de documento";
    }
    if (!this.solicitud.idTipoDocumento) {
      errores = "<br>Seleccione tipo de documento";
    }

    if (errores != "") {
      this.mostrarMensajeDialog(errores);
    }
    return errores == "";
  }

  mostrarMensajeDialog(mensaje) {
    const dialogRef = this.dialog.open(XsMessageBoxComponent, {
      width: "400px",
      panelClass: "xs-message-box-dlg",
      data: { titulo: "SSO", mensaje: mensaje, icono: "XS_IDEA" }
    });
  }

  sendMail() {
    let fullName = this.solicitud.apellidoPaterno +" "+ this.solicitud.apellidoMaterno +" "+ this.solicitud.nombres;
    let status = 'Aprobada';
    let display = "block";
    let password = this.solicitud.clave;
    let username = this.solicitud.usuario;;
    let observacion = "";
    let body2 = " <span style='font-family:arial;'>Atentamente,</br> Organismo de Evaluación y Fiscalización Ambiental</span>";
    let email = "admin@oefa.gob.pe";
    let message = this.buildMail(fullName, status, display, username, password, observacion, body2, email);

    let solicitud: any = {};
    solicitud.correoDestino = this.solicitud.correo;
    solicitud.asunto = "ESTADO DE SOLICITUD";
    solicitud.mensaje = message;
   // this.correoService.correoAvanzado(solicitud).then(res => { });
  }

  buildMail(fullName, status, display, username, password, observacion, body2, email): string {
    let mail = '<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd"><html xmlns="http://www.w3.org/1999/xhtml"><head><meta http-equiv="Content-Type" content="text/html; charset=utf-8" /><title>MTPE</title></head><body id="principal" style="margin:0;padding:0;background: white;"><table align="center" bgcolor="white" cellpadding="0" cellspacing="0" style="text-align:center;padding-top: 30px;margin-bottom: 20px " width="650px"><tbody><tr><td><table align="center" bgcolor="#FFFFFF" cellpadding="0" cellspacing="0" style="font-family:Arial; font-size:12px; border: 1px solid #000" width="100%"><tbody><tr height="130" style="background-color:#eee!important;"><td height="120" style="padding:0px 60px;width:100%;"> <a href="https://www.oefa.gob.pe/" target="_blank"> <img src="https://www.oefa.gob.pe/wp-content/themes/topbusiness/resource/img/bg/oefa-logo-header.png" alt="logo" /> </a></td></tr><tr><td height="4" style="background-color:#0089C2"></td></tr><tr><td><table border="0" cellpadding="0" cellspacing="0" style="width:100%;"><tbody><tr><td height="10"></td></tr><tr><td style="padding: 10px 60px; color: #333333; font-size: 13px; text-align: left; line-height: 2"><div style="margin-bottom: 5px"> <span>Estimado Usuario:</span> <b>${fullName}</b></div><div> <span>Su solicitud, se encuentra ${status}.<br/>Para mayor información comunícate con nosotros.</span> <br/> <b>${observacion}  </b></div><div style="display: ${display};"><div> <span>Usuario de Ingreso:</span></div><div> <span>${username}</span></div><div> <span>Contraseña de Ingreso:</span></div><div> <span>${password}</span><br><p>${body2}</p></div></div></td></tr><tr><td height="10"></td></tr><tr><table align="center" bgcolor="#999999" cellpadding="0" cellspacing="0" style="border-top: 4px solid #0089C2; background: #eee;padding:10px 0; height: 120px;" width="100%" ><tbody style="vertical-align:middle"><tr ><td height="65" width="60"></td><td align="left"><div style="font-size: 9px;"> <b style="font-size: 15px;">Correos de consultas</b> <br/><br/> <span>Atención al Administrado: <a href="mailto:${email}">${email}</a></span> <br/> <span>Ayuda Informática: <a href="mailto:soporte@oefa.gob.pe">soporte@oefa.gob.pe</a></span> <br/> <span>Webmaster: <a href="mailto:webmaster@oefa.gob.pe">webmaster@oefa.gob.pe</a></span> <br/><br/></div></td><td><div style="width:1px;height:80px; background-color:transparent"></div></td><td align="left" style="padding-left:25px;"><div style="font-size: 10px;"> <b style="font-size: 15px;">Contáctenos</b> <br/><br/> <span> Central: 204-9900 <br> Atención al Administrado: 204-9900 – Anexo: 7361<br> Ayuda Informática: 204-6000 / 204-6544 / 204-6545 </span> <br/><br/> <span> Avenida Faustino Sánchez Carrión<br> N° 603, 607 y 615 - Jesús María<br> Horario de Atención al Público:<br> Lunes a viernes 8:45 a 16:45<br> </span></div></td></tr></tbody></table></tr></tbody></table></td></tr></tbody></table></td></tr></tbody></table></body></html>';
    var res = mail.replace("${fullName}", fullName);
    var res = res.replace("${status}", status);
    var res = res.replace("${display}", display);
    var res = res.replace("${username}", username);
    var res = res.replace("${password}", password);
    var res = res.replace("${observacion}", observacion);
    var res = res.replace("${body2}", body2);
    var res = res.replace("${email}", email);
    var res = res.replace("${email}", email);
    return res;
  }
}
